import React from 'react'
import {translate} from 'i18n'
import {GiftShopRootScreen} from '../../../gift-shop'
import {ForkygramSearchFriends} from '../containers'

export default function ForkygramSearchFriendsScreen() {
  return (
    <GiftShopRootScreen
      id="search_friends"
      headerTitle={translate('forkygram:searchFriends')}
      showBadgeIcon={false}
      onBackButtonClicked={() => history.go(-1)}>
      <ForkygramSearchFriends />
    </GiftShopRootScreen>
  )
}
